import { HeroImage } from '../components/HeroImage';
import { createFileRoute } from '@tanstack/react-router';
import TestimonialSection from '../components/TestimonialSection';
import { useFetchClients } from '../hooks/useFetchClients';
import FormExample from '../components/FormExample';
import { Footer } from '../components/Footer';
import { usePageMeta } from '../hooks/usePageMeta';

export const Route = createFileRoute('/testimonials')({
  component: TestimonialsComponent,
});

function TestimonialsComponent() {
  usePageMeta(
    'Client Testimonials | Boyden Renovations',
    'See what homeowners are saying about their renovation experience with Boyden Renovations.'
  );
  const { clients, isLoading, isError } = useFetchClients();

  if (isLoading) {
    return (
      <div className="w-full h-[420px] flex items-center justify-center bg-stone-50">
        <div className="w-8 h-8 rounded-full border-2 border-amber-500 border-t-transparent animate-spin" />
      </div>
    );
  }

  if (isError || !clients) {
    return (
      <div className="w-full h-[420px] flex items-center justify-center bg-stone-50">
        <p className="text-stone-400 font-['Lato',sans-serif]">
          Unable to load testimonial.
        </p>
      </div>
    );
  }

  return (
    <div data-nav-theme="light">
      <HeroImage
        imageUrl="https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777656811/Website/Magree/magreephoto-5366.webp"
        title="Testimonials"
        overlayOpacity={0.2}
      />
      {clients.map((client, index) => (
        <TestimonialSection
          key={index}
          client={client}
          imgDirection={index % 2 === 0 ? 'left' : 'right'}
        />
      ))}
      <FormExample isLoaded={!!clients} />
      <Footer isLoaded={!!clients} />
    </div>
  );
}
